import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.string.repeat";
import "core-js/modules/es6.function.name";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { get } from 'lodash';
import ApiService from '../../../services/apiService';
import CoreCsvExportEmail from './email';
var TIME_RANGES = {
  hourly: ['CURRENT_HOUR', 'LAST_HOUR'],
  daily: ['CURRENT_HOUR', 'LAST_HOUR', 'CURRENT_DAY', 'LAST_DAY'],
  monthly: ['CURRENT_HOUR', 'LAST_HOUR', 'CURRENT_DAY', 'LAST_DAY', 'CURRENT_WEEK', 'LAST_WEEK', 'CURRENT_MONTH', 'LAST_MONTH'],
  yearly: ['CURRENT_HOUR', 'LAST_HOUR', 'CURRENT_DAY', 'LAST_DAY', 'CURRENT_WEEK', 'LAST_WEEK', 'CURRENT_MONTH', 'LAST_MONTH', 'CURRENT_YEAR', 'LAST_YEAR']
};
export default {
  name: 'CoreCsvExportDialogScheduled',
  components: {
    CoreCsvExportEmail: CoreCsvExportEmail
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    editObject: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    copyMode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      dialogIsReady: false,
      name: null,
      accountId: null,
      filter: [],
      filterType: 'digitalTwin',
      frequency: {
        repeat: 'monthly',
        month: null,
        day: null,
        hour: null,
        minute: null
      },
      validFrequency: false,
      validEmails: true,
      validCsvOptions: true,
      validThirdPartyData: false,
      timeRange: 'CURRENT_HOUR',
      jobs: [],
      searchTotalCount: null,
      dataAggregation: 'ALL',
      timezone: null,
      isReadonly: false,
      search: [],
      searchOperator: 'AND',
      stateIdentifiers: [],
      selectedStates: [],
      stateIdSearchInput: null,
      emailsData: {
        emails: [''],
        formIsValid: true,
        selectedMailConnector: null
      },
      csvOptions: {
        headers: [],
        includeHeaders: true
      },
      thirdPartyData: {
        selectedOutboundConnector: null,
        payload: null,
        bridgeId: null
      },
      selectedOption: 'downloadFileFromNiotix',
      mailConnectors: [],
      outboundConnectors: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'color'])), {}, {
    dataAggregationItems: function dataAggregationItems() {
      return [{
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.ALL'),
        value: 'ALL'
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.LAST'),
        value: 'LAST'
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.MAX'),
        value: 'MAX'
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.SUM'),
        value: 'SUM'
      }];
    },
    searchTotalCountMessage: function searchTotalCountMessage() {
      if (this.searchTotalCount === null || this.searchTotalCount === undefined || (this.filter || []).length === 0) {
        return null;
      }

      var typeDevice = this.filterType === 'digitalTwin' ? this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.digitalTwins') : this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.virtualDevices');

      if (this.searchTotalCount === -1) {
        return this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.totalCountError', {
          devices: typeDevice
        });
      }

      return this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.totalCount', {
        count: this.searchTotalCount,
        devices: typeDevice
      });
    },
    formIsValid: function formIsValid() {
      if (this.selectedOption === 'sendoutDownloadLink') {
        return Boolean(this.name && this.accountId && this.validFrequency && this.timeRange && this.validEmails && this.validCsvOptions && this.mailConnectors.length);
      } else if (this.selectedOption === 'forwardToThirdParty') {
        return Boolean(this.name && this.accountId && this.validFrequency && this.timeRange && this.validCsvOptions && this.validThirdPartyData && this.outboundConnectors.length);
      } else {
        return Boolean(this.name && this.accountId && this.validFrequency && this.timeRange && this.validCsvOptions);
      }
    },
    timeRangeItems: function timeRangeItems() {
      var _this = this;

      var ranges = TIME_RANGES[(this.frequency || {}).repeat] || [];
      return ranges.map(function (range) {
        return {
          value: range,
          text: _this.$i18n_t("BackgroundJobs.ScheduledExports.dialog.timeRange.items.".concat(range))
        };
      });
    },
    forwardOptions: function forwardOptions() {
      return [{
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.forward.downloadFileFromNiotix'),
        value: 'downloadFileFromNiotix'
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.forward.sendoutDownloadLink'),
        value: 'sendoutDownloadLink'
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.forward.forwardToThirdParty'),
        value: 'forwardToThirdParty'
      }];
    }
  }),
  watch: {
    isOpen: function isOpen(newVal, oldVal) {
      var _this2 = this;

      // set to false when the dialog was closed and is now opened again
      // for some reason it doesn't work to just set it to false in the close() method
      this.dialogIsReady = newVal === oldVal;

      if (newVal && this.editObject !== null) {
        this.$nextTick(function () {
          _this2.initEditDialog();
        });
      } else {
        this.dialogIsReady = true;
      }
    },
    accountId: function accountId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.jeffBridges();
        this.fetchFilterDeviceCount(this.filterType, this.filter);

        if (newVal && oldVal) {
          this.selectedOption = 'downloadFileFromNiotix';
        }
      }
    },
    filterType: function filterType(newVal, oldVal) {
      // https://digimondo.atlassian.net/browse/RD-6673
      // the filterType is 'digitalTwin' per default but in read-only mode
      // it might change according to the editObject to 'virtualDevice'
      // check if dialog is read-only mode and if so do nothing to prevent
      // overwriting search, stateIdentifiers, selectedStates and searchTotalCount
      if (this.isReadonly) {
        return;
      }

      if (newVal !== oldVal) {
        this.search = [];
        this.stateIdentifiers = [];
        this.selectedStates = [];
        this.searchTotalCount = null;
      }
    },
    'frequency.formIsValid': function frequencyFormIsValid() {
      this.validFrequency = this.frequency.formIsValid;
    },
    'emailsData.formIsValid': function emailsDataFormIsValid() {
      this.validEmails = this.emailsData.formIsValid;
    },
    'csvOptions.formIsValid': function csvOptionsFormIsValid() {
      this.validCsvOptions = this.csvOptions.formIsValid;
    },
    'thirdPartyData.formIsValid': function thirdPartyDataFormIsValid() {
      this.validThirdPartyData = this.thirdPartyData.formIsValid;
    },
    'frequency.repeat': function frequencyRepeat() {
      var ranges = TIME_RANGES[(this.frequency || {}).repeat] || [];

      if (!ranges.includes(this.timeRange)) {
        this.timeRange = ranges[0];
      }
    }
  },
  mounted: function mounted() {
    this.fetchAccounts();
  },
  methods: {
    initEditDialog: function initEditDialog() {
      var criteria = get(this, 'editObject.parameters.criteria', {});
      this.isReadonly = true;
      this.name = this.editObject.title;
      this.accountId = this.editObject.tenantId;
      this.timezone = this.editObject.timezone;
      this.timeRange = criteria.range || 'CURRENT_HOUR';
      this.dataAggregation = criteria.aggregateFunction || 'ALL';
      this.frequency = this.fromCrontab(this.editObject.timeExpression);
      this.filterType = criteria.type;
      this.search = (criteria.search_items || []).map(function (item) {
        return {
          param: item.param || item.variable,
          search: item.search,
          key: item.key
        };
      });
      var emailsData = get(this, 'editObject.parameters.emailsData', {});

      if (emailsData.bridgeId && emailsData.emails && emailsData.html) {
        this.emailsData = get(this, 'editObject.parameters.emailsData');
      }

      this.emailsData.selectedMailConnector = get(this, 'editObject.parameters.emailsData', {}).bridgeId;
      this.csvOptions = get(this, 'editObject.parameters.csvOptions');
      this.thirdPartyData = get(this, 'editObject.parameters.thirdPartyData', {});
      this.thirdPartyData.selectedOutboundConnector = get(this, 'editObject.parameters.thirdPartyData', {}).bridgeId;
      this.selectedOption = emailsData.html || emailsData.subject || emailsData.emails || this.emailsData.selectedMailConnector ? 'sendoutDownloadLink' : this.thirdPartyData.payload || this.thirdPartyData.selectedOutboundConnector ? 'forwardToThirdParty' : 'downloadFileFromNiotix';
      this.searchOperator = criteria.search_operator || 'AND';
      this.selectedStates = criteria.stateIdentifiers || [];
      this.stateIdentifiers = (criteria.stateIdentifiers || []).map(function (item) {
        return {
          key: item
        };
      });

      if (this.copyMode) {
        this.updateFilter(this.search, this.searchOperator);
      }

      this.dialogIsReady = true;
    },
    resetDialog: function resetDialog() {
      this.isReadonly = false;
      this.name = null;
      this.accountId = null;
      this.filter = [];
      this.filterType = 'digitalTwin';
      this.frequency = {
        repeat: 'monthly',
        month: null,
        day: null,
        hour: null,
        minute: null
      };
      this.validFrequency = false;
      this.timeRange = 'CURRENT_HOUR';
      this.dataAggregation = 'ALL';
      this.searchOperator = 'AND';
      this.searchItems = [];
      this.search = [];
      this.stateIdentifiers = [];
      this.selectedStates = [];
      this.timezone = null;
      this.emailsData = {
        emails: [''],
        selectedMailConnector: null,
        subject: '',
        html: ''
      };
      this.csvOptions = {
        headers: [],
        includeHeaders: true
      };
      this.thirdPartyData = {
        selectedOutboundConnector: null,
        payload: null
      };
      this.deviceBridgesForAccount = [];
      this.selectedMailConnector = null;
      this.selectedOutboundConnector = null;
      this.accountId = null;
      this.selectedOption = 'downloadFileFromNiotix';
    },
    updateFilter: function updateFilter(search, operator) {
      this.filter = search;
      this.searchOperator = operator;
      this.fetchFilterDeviceCount(this.filterType, this.filter, this.searchOperator);
    },
    fetchFilterDeviceCount: function fetchFilterDeviceCount(type, filter, operator) {
      var _this3 = this;

      if (this.isReadonly && !this.copyMode) {
        return;
      }

      var searchItems = (filter || []).map(function (item) {
        return {
          variable: item.param,
          // support item.search.value === null, so do not simply have a >search.value || search< expression
          search: (item.search || {}).value === undefined ? item.search : item.search.value,
          key: item.key
        };
      });
      var accountFilter = this.accountId ? [{
        type: 'tenantIds',
        ids: [this.accountId]
      }] : [];

      if (searchItems.length === 0) {
        // if there are no search items, in case the search filter was emptied, reset the total count
        // and return. do not search for all available devices.
        this.searchTotalCount = null;
        this.stateIdentifiers = [];
        this.selectedStates = [];
        return;
      }

      var apiMethod = type === 'virtualDevice' ? ApiService.virtualDeviceFetch : ApiService.digitalTwinsFetch;
      var apiParams = [this, // context
      null, // userId
      [], // scopeIds
      accountFilter, // filters
      null, // options
      {
        variable: 'id',
        direction: 'ASC'
      }, // orderBy
      0, // offset
      1, // limit
      searchItems];

      if (type === 'virtualDevice') {
        apiParams.push(undefined, true, // include identifiers
        operator);
      } else {
        apiParams.push(true // include identifiers
        );
      }

      apiMethod.apply(void 0, apiParams).then(function (result) {
        _this3.searchTotalCount = result.totalCount;
        _this3.stateIdentifiers = result.identifiers.sort(function (a, b) {
          return a.key.localeCompare(b.key, undefined, {
            numeric: true
          });
        });
      }).catch(function () {
        _this3.searchTotalCount = -1;
        _this3.stateIdentifiers = [];
        _this3.selectedStates = [];
      });
    },
    fromCrontab: function fromCrontab(crontab) {
      var _crontab$split$filter = crontab.split(' ').filter(function (item) {
        return item !== '*';
      }),
          _crontab$split$filter2 = _slicedToArray(_crontab$split$filter, 4),
          minute = _crontab$split$filter2[0],
          hour = _crontab$split$filter2[1],
          day = _crontab$split$filter2[2],
          month = _crontab$split$filter2[3];

      var freq = null;

      if (minute >= 0, hour >= 0, day >= 1, month >= 1) {
        freq = 'yearly';
      } else if (minute >= 0, hour >= 0, day >= 1) {
        freq = 'monthly';
      } else if (minute >= 0, hour >= 0) {
        freq = 'daily';
      } else if (minute >= 0) {
        freq = 'hourly';
      }

      return {
        repeat: freq,
        month: month,
        day: day,
        hour: hour,
        minute: minute
      };
    },
    toCrontab: function toCrontab(frequency) {
      // Convert null or undefined values to '*'
      for (var key in frequency) {
        if (frequency[key] === null || frequency[key] === undefined) {
          frequency[key] = '*';
        }
      }

      return "".concat(frequency.minute, " ").concat(frequency.hour, " ").concat(frequency.day, " ").concat(frequency.month, " *");
    },
    handleSave: function handleSave() {
      var _this4 = this;

      var search_items = this.filter.map(function (item) {
        return {
          variable: item.param,
          // support item.search.value === null, so do not simply have a >search.value || search< expression
          search: (item.search || {}).value === undefined ? item.search : item.search.value,
          key: item.key
        };
      });
      var payload = {
        active: true,
        tenantId: this.accountId,
        title: this.name,
        timeExpression: this.toCrontab(this.frequency),
        timezone: this.timezone,
        jobType: 'deviceStatesCsvExport',
        parameters: {
          criteria: {
            type: this.filterType,
            search_items: JSON.parse(JSON.stringify(search_items)),
            search_operator: this.searchOperator,
            stateIdentifiers: this.selectedStates,
            range: this.timeRange,
            aggregateFunction: this.dataAggregation
          },
          emailsData: this.selectedOption === 'sendoutDownloadLink' ? {
            emails: this.emailsData.emails,
            bridgeId: this.emailsData.selectedMailConnector.id,
            subject: this.emailsData.subject,
            html: this.emailsData.html
          } : {},
          thirdPartyData: this.selectedOption === 'forwardToThirdParty' ? {
            bridgeId: this.thirdPartyData.selectedOutboundConnector.id,
            payload: this.thirdPartyData.payload
          } : {},
          csvOptions: this.csvOptions.includeHeaders ? {
            headers: this.csvOptions.headers.map(function (c) {
              return {
                name: c.name,
                mappedValue: c.mappedValue
              };
            }),
            includeHeaders: true
          } : {
            includeHeaders: false
          }
        }
      };
      ApiService.createJobDefinition(payload).then(function () {
        _this4.$snack(_this4.$i18n_t('BackgroundJobs.ScheduledExports.snacks.createSuccess'), 'success');

        _this4.$emit('save');
      }).catch(function (err) {
        _this4.$snack(_this4.$i18n_t('BackgroundJobs.ScheduledExports.snacks.createError'), 'error');

        console.error(err);
      });
      this.close();
    },
    close: function close() {
      this.resetDialog();
      this.$emit('close');
    },
    fetchAccounts: function fetchAccounts() {
      var _this5 = this;

      this.$store.dispatch('app/loadAccounts').then(function (accounts) {
        // filter the root-tenant, because that one does not have a twin to attach the new device to
        _this5.accounts = accounts.filter(function (t) {
          return !t.isRootTenant;
        });
      }).catch(function (error) {
        console.error(error);

        _this5.$snack(_this5.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
      });
    },
    jeffBridges: function jeffBridges() {
      var _this6 = this;

      this.mailConnectors = [];
      this.outboundConnectors = [];

      if (this.accountId === null) {
        return;
      }

      Promise.all([ApiService.getBridgeTypes().then(function (bridgeTypes) {
        return bridgeTypes.filter(function (type) {
          return Object.keys(get(type, 'manifest.commands.instance', {})).length > 0;
        });
      }), ApiService.getBridgesForTenant(this.accountId)]).then(function (results) {
        _this6.bridgeTypes = results[0];
        _this6.mailConnectors = results[1].filter(function (bridgeInstance) {
          return bridgeInstance.type === 'bridge-mail';
        }).map(function (bridge) {
          return bridge.state === 'active' ? bridge : _objectSpread(_objectSpread({}, bridge), {}, {
            name: "".concat(bridge.name, " (inactive)"),
            disabled: true
          });
        });
        _this6.outboundConnectors = results[1].filter(function (bridgeInstance) {
          return bridgeInstance.type === 'bridge-mqtt-outbound' || bridgeInstance.type === 'bridge-webhook';
        }).map(function (bridge) {
          return bridge.state === 'active' ? bridge : _objectSpread(_objectSpread({}, bridge), {}, {
            name: "".concat(bridge.name, " (inactive)"),
            disabled: true
          });
        });

        if (!_this6.selectedMailConnector) {
          _this6.selectedMailConnector = _this6.mailConnectors[0];
        }

        if (!_this6.selectedOutboundConnector) {
          _this6.selectedOutboundConnector = _this6.outboundConnectors[0];
        }
      }).catch(function (error) {
        console.error('Error fetching bridges', error);

        _this6.$snack(_this6.$i18n_t('Connectors.Connectors.errors.connectionError'), 'error');
      });
    }
  }
};